<template>
  <div class="custSlider">
    <hooper :itemsToShow="show" :itemsToSlide="3" pagination="yes" :infiniteScroll="true" style="height:620px">
      <slide v-for="(product, i) in products" :key="'prods-' + i" :index="i" style="padding:8px;height:620px;">
        <Product @reload="reload" class="revDirection" :loading="loading" :i="i" :product="product" />
      </slide>
      <hooper-navigation slot="hooper-addons">
      </hooper-navigation>
    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination,
  Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
import Product from './Product'
export default {
  components: {
    Product,
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation
  },
  props:['products', 'i', 'loading'],
  computed:{
    cart(){
      return this.$store.getters.cart
    },
    show () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 1
        case 'sm': return 1
        case 'md': return 4
        case 'lg': return 4
        case 'xl': return 4
      }
    },
  },
  methods: {
    reload(){
      this.$emit('reload')
    },
    addToCart(product) {
      this.$store.dispatch('addToCart', product)
    },
  }
}
</script>

<style>
.custSlider .hooper-list,
.custSlider .hooper,
.custSlider .hooper-track,
.custSlider .hooper-slide,
.custSlider {
  direction: ltr !important;
}
.revDirection * {
  direction: rtl !important;
  text-align: right;
}
.custSlider .hooper-list,
.custSlider .hooper,
.custSlider {
  height:620px;
}
.custSlider .hooper-list {
  height:620px;
}

.custSlider .hooper-track {
  padding:20px 0 !important;
}

.hooper-next,
.hooper-prev {
  background: #BE202E;
  border-radius: 50%;
  fill:#fff;
  padding: 2px;
  height: 28px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
</style>